import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_IIRGD } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CiliSimplificadaRequest, Types } from './types';

// ACTIONS
import { ciliSimplificadaSuccess, ciliSimplificadaFailure } from './actions';

function* ciliSimplificadaRequest(request: ReducerAction) {
	const { payload }: { payload: CiliSimplificadaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_IIRGD,
		`emissao-carteira-identidade/${CHANNEL}/cili-simplificada`,
		payload,
	);

	if (response.status === 200) {
		yield put(ciliSimplificadaSuccess(response.data));
	} else if (response.error) {
		yield put(ciliSimplificadaFailure());
	}
}

export default all([
	takeLatest(Types.CILI_SIMPLIFICADA_REQUEST, ciliSimplificadaRequest),
]);
